export const SESSION_COOKIE = 'elowen_session';
export const TOTP_PENDING_COOKIE = 'elowen_totp_pending';
export const RETURN_COOKIE = 'elowen_return';
export const IMPERSONATING_COOKIE = 'elowen_as';

export function cookieName(name: string, secure: boolean): string {
  return secure ? `__Host-${name}` : name;
}
